import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import { fromDto } from '../models/user-trading-analytics'
import { UserTradingAnalyticsPeriod } from '../models/user-trading-analytics-period'

import type { DelugeId } from '@root/entities/user-short'
import type { WalletAddress } from '@root/entities/wallet'
import type { UserTradingAnalyticsPeriodDto } from '@root/shared/api/TradeApi'

interface FetchUserTradingAnalyticsRequestActionPayload {
  delugeId: DelugeId
  network: Network.Network
  period: UserTradingAnalyticsPeriod
  walletAddresses: ReadonlyArray<WalletAddress>
}

const PERIOD_TO_DTO_MAP: Record<
  UserTradingAnalyticsPeriod,
  UserTradingAnalyticsPeriodDto
> = {
  [UserTradingAnalyticsPeriod.ALL]: 'ALL',
  [UserTradingAnalyticsPeriod['7D']]: '7D',
  [UserTradingAnalyticsPeriod['1D']]: '1D',
  [UserTradingAnalyticsPeriod['12H']]: '12H',
  [UserTradingAnalyticsPeriod['6H']]: '6H',
  [UserTradingAnalyticsPeriod['1H']]: '1H',
}

export const fetchUserTradingAnalyticsRequestAction = action(
  async (ctx, payload: FetchUserTradingAnalyticsRequestActionPayload) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userTradingAnalyticsCreate, [
        {
          delugeId: payload.delugeId,
          period: PERIOD_TO_DTO_MAP[payload.period],
          network: Network.toDto(payload.network),
          walletAddresses:
            payload.walletAddresses.length === 0
              ? undefined
              : [...payload.walletAddresses],
        },
      ]),
    )

    return pipe(
      result,
      Result.map((x) => fromDto(x)),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'fetchUserTradingAnalyticsRequestAction',
)
